var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntregaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconAdicionales/Entrega"
  }, /*#__PURE__*/React.createElement("path", {
    id: "IconAdicionales/Entrega_2",
    d: "M31.3437 17.1875H30.5625V11.9092C30.5625 11.2891 30.3135 10.6934 29.874 10.2539L24.9961 5.37598C24.5566 4.93652 23.9609 4.6875 23.3408 4.6875H21.1875V2.34375C21.1875 1.0498 20.1377 0 18.8437 0H3.21875C1.9248 0 0.875 1.0498 0.875 2.34375V17.9688C0.875 19.2627 1.9248 20.3125 3.21875 20.3125H4C4 22.9004 6.09961 25 8.6875 25C11.2754 25 13.375 22.9004 13.375 20.3125H19.625C19.625 22.9004 21.7246 25 24.3125 25C26.9004 25 29 22.9004 29 20.3125H31.3437C31.7734 20.3125 32.125 19.9609 32.125 19.5312V17.9688C32.125 17.5391 31.7734 17.1875 31.3437 17.1875ZM8.6875 22.6562C7.39355 22.6562 6.34375 21.6064 6.34375 20.3125C6.34375 19.0186 7.39355 17.9688 8.6875 17.9688C9.98144 17.9688 11.0312 19.0186 11.0312 20.3125C11.0312 21.6064 9.98144 22.6562 8.6875 22.6562ZM24.3125 22.6562C23.0186 22.6562 21.9687 21.6064 21.9687 20.3125C21.9687 19.0186 23.0186 17.9688 24.3125 17.9688C25.6064 17.9688 26.6562 19.0186 26.6562 20.3125C26.6562 21.6064 25.6064 22.6562 24.3125 22.6562ZM28.2187 12.5H21.1875V7.03125H23.3408L28.2187 11.9092V12.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntregaIcon);
export default __webpack_public_path__ + "static/media/entrega_icon.749d15d6f547b0690cb02505276809f8.svg";
export { ForwardRef as ReactComponent };